import Swal from "sweetalert2";
//sweet alerts for displaying error and info messages to the user and a loader
export default {
  methods: {
    // methods to show and close loader
    show_loader(message, minDisplayTime = 800) {
      const loader = {
        startTime: Date.now(),
        minDisplayTime: minDisplayTime,
        instance: null,
        isClosed: false
      };

      return new Promise((resolve) => {
        loader.instance = Swal.fire({
          text: message,
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
            resolve(loader);
          }
        });
      });
    },

    /**
     * Closes the loader, ensuring it's shown for at least the minimum display time
     */
    async close_loader(loader) {
      if (!loader || loader.isClosed) return;

      const elapsed = Date.now() - loader.startTime;
      const remainingTime = loader.minDisplayTime - elapsed;

      if (remainingTime > 0) {
        await new Promise(resolve => setTimeout(resolve, remainingTime));
      }

      if (loader.instance && typeof loader.instance.close === 'function') {
        loader.instance.close();
      }
      loader.isClosed = true;
    },
    show_error(message) {
      Swal.fire({
        icon: "error",
        text: message,
        showConfirmButton: true,
        customClass: {
          title: 'small-title',
          content: 'small-text'
        }
      })
    },
    show_toast(message, icon = "success", title = "") {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon,
        title: title || message,
        text: title ? message : "",
        showConfirmButton: false,
        timer: 2600,
        timerProgressBar: false,
        showClass: {
          popup: 'swal2-toast-show'
        },
        hideClass: {
          popup: 'swal2-toast-hide'
        },
        customClass: {
          popup: 'success-toast-popup',
          title: 'success-toast-title',
          icon: 'success-toast-icon',
          iconHtml: 'success-toast-icon-check'
        }
      });
    },
    show_error_toast(message) {
      this.show_toast(message, "error");
    },
    show_warning_toast(message) {
      this.show_toast(message, "warning");
    },
    show_info_toast(message) {
      this.show_toast(message, "info");
    },
    show_confirm(title, text, confirmCallback, cancelCallback = null) {
      Swal.fire({
        title: title,
        text: text,
        icon: "warning",
        iconHtml: "!",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        customClass: {
          popup: 'danger-confirm-popup',
          title: 'danger-confirm-title',
          htmlContainer: 'danger-confirm-text',
          icon: 'danger-confirm-icon',
          iconHtml: 'danger-confirm-icon-mark',
          actions: 'danger-confirm-actions',
          confirmButton: 'danger-confirm-btn danger-confirm-btn-primary',
          cancelButton: 'danger-confirm-btn danger-confirm-btn-secondary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          if (confirmCallback && typeof confirmCallback === 'function') {
            confirmCallback();
          }
        } else if (result.isDismissed) {
          if (cancelCallback && typeof cancelCallback === 'function') {
            cancelCallback();
          }
        }
      });
    },
    show_warning(title, text) {
      Swal.fire({
        title: title,
        text: text,
        icon: "warning",
        iconHtml: "!",
        showConfirmButton: true,
        confirmButtonText: "OK",
        customClass: {
          popup: 'danger-confirm-popup',
          title: 'danger-confirm-title',
          htmlContainer: 'danger-confirm-text',
          icon: 'danger-confirm-icon',
          iconHtml: 'danger-confirm-icon-mark',
          actions: 'danger-confirm-actions',
          confirmButton: 'danger-confirm-btn danger-confirm-btn-primary'
        }
      });
    },
    show_info(message) {
      Swal.fire({
        icon: "info",
        title: "Validation!",
        text: message,
        showConfirmButton: true,
        customClass: {
          title: 'small-title',
          content: 'small-text'
        }
      })
    },
    show_success(message) {
      this.show_toast(message, "success");
    },
    close_modal(modal_id) {
      const modal_element = document.getElementById(modal_id);
      if (modal_element) {
        const modal_instance = window.bootstrap.Modal.getInstance(modal_element) || new window.bootstrap.Modal(modal_element);
        modal_instance.hide();
      }
    }
  },
};
